import { CdkPortalOutlet, DomPortal } from '@angular/cdk/portal';
import {
   AfterViewInit,
   ChangeDetectionStrategy,
   Component,
   ElementRef,
   Input,
   OnDestroy,
   ViewChild,
} from '@angular/core';
import { XAxisTicksComponent as NgxChartsXAxisTicksComponent } from '@swimlane/ngx-charts';
import { Orientation } from '../graphs/models/orientation.enum';

/**
 * Component that renders the y-axis ticks and reference lines.
 * Optionally accepts a portal outlet to render custom reference lines into,
 * which allows reference lines to be rendered elsewhere within a chart.
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'g[qmg-charts-x-axis-ticks]',
    templateUrl: './x-axis-ticks.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class XAxisTicksComponent extends NgxChartsXAxisTicksComponent implements AfterViewInit, OnDestroy {
   @Input() referenceLines: any[];

   @Input() showRefLines: boolean = true;

   @Input() showRefLabels: boolean = true;

   @Input() referenceLinesOutlet?: CdkPortalOutlet;

   @ViewChild('referenceLinesEl', { read: ElementRef }) referenceLinesEl: ElementRef;

   /**
    * The value of the reference line with the lowest value.
    */
   refMin: number;

   /**
    * The value of the reference line with the highest value.
    */
   refMax: number;

   /**
    * The number of reference lines.
    */
   referenceLineLength: number = 0;

   readonly Orientation = Orientation;

   ngAfterViewInit(): void {
      super.ngAfterViewInit();

      this.referenceLinesOutlet?.attach(new DomPortal(this.referenceLinesEl.nativeElement));
   }

   ngOnDestroy(): void {
      // Only detach, not dispose, because the outlet is not a part of this component and may be reused.
      this.referenceLinesOutlet?.detach();
   }

   update(): void {
      super.update();

      this.refMin = this.adjustedScale(
         Math.min.apply(
            null,
            this.referenceLines.map((item) => item.value)
         )
      );

      this.refMax = this.adjustedScale(
         Math.max.apply(
            null,
            this.referenceLines.map((item) => item.value)
         )
      );

      this.referenceLineLength = this.referenceLines.length;
   }

   refLineTransform(value: number): string {
      return `translate(${this.adjustedScale(value)},0)`;
   }
}
